import styled from 'styled-components';
import { hexToRgbA } from '../../../../utils/colors';
import { THEME } from '../../../../themes';
import { Body2Font, Subtitle2Font } from '../../../../themes/fonts';
import PerfectButton from '../../../Common/Buttons/perfect-base-button/perfect-base-button.component';

export const CurrentPlanWrapper = styled.div`
  background-color: ${hexToRgbA(
    THEME.COLORS.PRIMARY_DARK,
    THEME.OPACITY.DIVIDER,
  )};
  border-radius: ${THEME.RADIUS.ROUNDISH};
  padding: ${THEME.SPACING.TINO} ${THEME.SPACING.MEDIUM};
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const CurrentPlanDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CurrentPlanTitle = styled.div`
  ${Subtitle2Font};
  color: ${THEME.COLORS.CONTENT_A};
  opacity: 1;
  font-weight: bold;
`;

export const CurrentPlanSubtitle = styled.div`
  ${Body2Font};
  color: ${THEME.COLORS.CONTENT_A};
  opacity: ${THEME.OPACITY.MED};
`;

export const ManageYourPlanButton = styled(PerfectButton)`
  color: ${THEME.COLORS.CONTENT_A};
  opacity: ${THEME.OPACITY.MED};
  font-size: ${THEME.FONT_SIZE.BASE};
  font-weight: bold;
  letter-spacing: 1.34px;
  text-transform: uppercase;
  background-color: transparent;
  padding: 0;
`;
